import { Navbar } from "@/components/navigation"
import { DISCORD_INVITE_LINK } from "@/components/footer"
import { MetaData } from "@/domains/common/layout/metadata"
import { ProfessionalLandingPageComposite } from "@/domains/landing-page/components/professional-landing-page-composite"
import { TronGridBackgroundView } from "@/domains/landing-page/components/tron-grid-background-view"

const SITE_URL = "https://scale.farm"
const HOME_DESCRIPTION =
  "Scale is a Base-native MetaIndex for swaps, liquidity incentives, veSCALE locks, voting rewards, and transparent protocol analytics."

const HOME_JSON_LD: Record<string, unknown>[] = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "Scale",
    url: SITE_URL,
    logo: `${SITE_URL}/images/landing/hero-bust-cutout.png`,
    description: HOME_DESCRIPTION,
    sameAs: [DISCORD_INVITE_LINK],
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "Scale",
    url: SITE_URL,
    description: HOME_DESCRIPTION,
  },
]

function LandingPage() {
  return (
    <div className="relative isolate min-h-svh bg-p500">
      <TronGridBackgroundView variant="homepage" />
      <MetaData
        title="Base Liquidity & Real Yield"
        description={HOME_DESCRIPTION}
        canonicalUrl={SITE_URL}
        imageUrl={`${SITE_URL}/images/landing/hero-bust-cutout.png`}
        jsonLd={HOME_JSON_LD}
      />
      <Navbar
        className="absolute inset-x-0 top-0 z-30"
        navClassName="rounded-full bg-white/[0.06] px-2 shadow-lg shadow-black/20 ring-1 ring-white/10 backdrop-blur-md"
      />
      <div className="relative z-10">
        <ProfessionalLandingPageComposite />
      </div>
    </div>
  )
}

export default LandingPage
